import "core-js/modules/es.array.concat.js";
import { finectAPI } from '@finect/front-utils/finectAPI';
import { getFundClass } from '@finect/front-resources/Products';
export var fundClassTimeseries = function fundClassTimeseries(type, fund) {
  var fundClass = fund.class ? getFundClass(fund) : {
    id: fund.id
  };
  var now = new Date();
  now.setFullYear(now.getFullYear() - 1);
  var start = now.toISOString().substring(0, 10);
  return finectAPI({
    version: 'v4',
    path: "products/collectives/".concat(type, "/").concat(fundClass.id, "/timeseries?start=").concat(start),
    method: 'GET',
    onSuccess: function onSuccess(_ref) {
      var data = _ref.data;
      return {
        fund: fund,
        prices: data
      };
    }
  });
};